import React from "react";
import Hint from "@bonprix/pattern-library/templates/hint/default";

export default function InputGroup({
  error = "",
  disabled = false,
  suggestionMessage,
  optionalMessage,
  className,
  children,
  jshModule = null,
  jshConfig = null,
  attributes = {},
  testRefs = {},
  hasRows = false,
}) {
  const labelClasses = `${className}${error ? " is-error" : ""}${
    disabled ? " is-disabled" : ""
  }${suggestionMessage ? " is-suggestion" : ""}${
    optionalMessage ? " is-optional" : ""
  }`;

  let errorMessage = null;
  if (error && typeof error === "string") {
    errorMessage = <Hint className="input-group__error">{error}</Hint>;
  } else if (error && Array.isArray(error)) {
    errorMessage = error.map((message, index) => {
      return (
        <Hint
          className={
            "input-group__error" +
            (index === 0 ? " input-group__error--first" : "")
          }
        >
          {message}
        </Hint>
      );
    });
  }

  const TagType = hasRows ? "div" : "label";
  return (
    <TagType
      className={labelClasses}
      jsh-input__wrapper="true"
      jsh-module={jshModule}
      jsh-config={jshConfig}
      {...attributes}
      {...testRefs}
    >
      {children}
      {errorMessage}
      {optionalMessage ? (
        <div className="input-group__optional">{optionalMessage}</div>
      ) : null}
      {suggestionMessage ? (
        <div className="input-group__suggestion">{suggestionMessage}</div>
      ) : null}
    </TagType>
  );
}
